<script setup lang="ts">
    import { inject } from 'vue'
    import PkChatbotMessages from './PkChatbotMessages.vue'
    import PkChatbotInput from './PkChatbotInput.vue'
    import PkToolShowMultipleChoice from './PkToolShowMultipleChoice.vue'
    import PkToolShowArtifact from './PkToolShowArtifact.vue'
    import PkToolShowEmail from './PkToolShowEmail.vue'
    import PkToolShowWebPages from './PkToolShowWebPages.vue'
    import PkToolShowProducts from './PkToolShowProducts.vue'
    import PkToolShowContactForm from './PkToolShowContactForm.vue'
    import { chatbotContextKey } from './constants'

    const ctx = inject(chatbotContextKey)!
</script>

<template>
    <!-- #region messages -->
    <PkChatbotMessages
        class="flex flex-col flex-1 min-h-0 p-md overflow-y-auto"
        :name="ctx.name.value"
        :messages="ctx.messages.value"
        :status="ctx.chat.value.status"
        :error="ctx.chat.value.error"
        :main-color="ctx.agentInterface.value?.mainColor"
        :revised-answers="ctx.revisedAnswers.value"
        :actions="ctx.actions.value"
        :logo="ctx.agentInterface.value?.logo"
        :message-feedbacks="ctx.messageFeedbacks.value"
        :feedback-message-id="ctx.feedbackDialogMessage.value?.id"
        :feedback-loading="ctx.isFeedbackSubmitting.value"
        :feedback-submitted="ctx.isFeedbackSubmitted.value"
        :feedback-error="ctx.feedbackSubmitError.value"
        @feedback-submit="ctx.onFeedbackSubmit($event)"
        @feedback-close="ctx.feedbackDialogMessage.value = undefined"
        @regenerate="ctx.regenerate"
        @auto-retry="ctx.regenerate"
        @reset-chat="ctx.startNewChat"
        @show-info="ctx.emit('show-info', $event)"
        @revise="ctx.emit('revise', $event)"
        @upvote="ctx.onUpvote"
        @downvote="ctx.onDownvote"
        @feedback="ctx.onFeedback">
        <template #tool-showArtifact="{ part }">
            <PkToolShowArtifact :part />
        </template>
        <template #tool-showEmail="{ part }">
            <PkToolShowEmail :part />
        </template>
        <template #tool-showWebPages="{ part }">
            <PkToolShowWebPages :part />
        </template>
        <template #tool-showProducts="{ part }">
            <PkToolShowProducts :part />
        </template>
        <template #tool-showContactForm="{ part }">
            <PkToolShowContactForm
                :part
                :readonly="!ctx.api"
                :submitted="ctx.isLeadSubmitted.value"
                :loading="ctx.isLoadingSubmitLead.value"
                :error="ctx.submitLeadError.value"
                @submit="ctx.onLeadSubmit" />
        </template>
        <template #tool-showMultipleChoice="{ part }">
            <transition mode="out-in">
                <PkToolShowMultipleChoice
                    :part
                    @select="
                        ctx.addToolOutput({
                            tool: 'showMultipleChoice',
                            toolCallId: (part as any).toolCallId,
                            output: $event,
                        })
                    " />
            </transition>
        </template>
    </PkChatbotMessages>
    <!-- #endregion -->

    <!-- #region input -->
    <PkChatbotInput
        v-model="ctx.input.value"
        :placeholder="ctx.inputMessagePlaceholder.value"
        :dismissable-notice="
            ctx.agentInterface.value?.dismissableNotice &&
            ctx.chat.value.messages.length <= 1
                ? ctx.agentInterface.value?.dismissableNotice
                : undefined
        "
        :status="ctx.chat.value.status"
        @stop-generation="ctx.stopGeneration"
        @submit="ctx.handleSubmit" />
    <!-- #endregion -->
</template>
